import type { LocationState } from 'redux-first-router';
import { connect } from 'react-redux';
import type { UserProps } from '@user/.';
import User from '@user/.';

const mapStateToProps = ({
  location,
}: {
  location: LocationState;
}): UserProps => {
  return { route: location.type };
};

export default connect(mapStateToProps)(User);
